import { SelectAsync } from "../../lib/form-component";
import React from "react";

export function Filter(props) {
  return (
    <SelectAsync
      isClearable={true}
      defaultOptions={true}
      creatable={false}
      required={false}
      {...props}
    />
  );
}
